import { FieldErrors, UseFormRegister } from "react-hook-form";

import { URL_VALIDATION_REG_EX } from "../../../../helpers/helpers";
import NotificationBlock from "../../../notificationBlock/NotificationBlock";
import Input from "../../../ui/input/Input";
import styles from "./AddUrlModalContent.module.scss";

type UrlFormValues = {
  url: string;
};

interface AddUrlModalContentProps {
  register: UseFormRegister<UrlFormValues>;
  errors: FieldErrors<UrlFormValues>;
  urlServerError: string | null;
}

const AddUrlModalContent = ({
  register,
  errors,
  urlServerError,
}: AddUrlModalContentProps) => (
  <>
    <p>
      You can add a custom URL that wasn't (or can't be) detected by the
      crawler. For example, a page with a dynamic URL that is neither listed on
      any page nor it is present in the sitemap.
    </p>
    <form id="addUrlModal">
      <Input
        placeholder="https://example.com/custom-page"
        {...register("url", {
          required: true,
          pattern: {
            value: URL_VALIDATION_REG_EX,
            message: "Please enter a valid URL",
          },
        })}
        errormessage={
          errors.url ? errors.url.message || "Please enter a valid URL" : ""
        }
      />
      {urlServerError && (
        <div className={styles.serverError}>
          <NotificationBlock type="danger" message={urlServerError} />
        </div>
      )}
    </form>
  </>
);

export default AddUrlModalContent;
